<script>
import * as Sentry from '@sentry/vue';
import { mapGetters } from 'vuex';

export default {
    name: 'SentryHandler',

    computed: {
        ...mapGetters('Auth', ['user']),
    },

    watch: {
        user(newUser) {
            if (newUser) {
                this.initSentryUser();
            }
        },
    },

    methods: {
        initSentryUser() {
            Sentry.configureScope(scope => {
                scope.setUser(this.user);
            });
        },
    },

    render: () => null,
};
</script>
